export default __webpack_public_path__ + "static/media/cpLaundryPassNewsPinkEn.da1ebb57.jpg";